import { departmentEndPoints } from '@Services/data/ApiHandler';
import store from '@Services/redux/Store';
import { IDepartment } from './Interfaces';
import { DepartmentActions } from './Reducer';

const Api = {
    getDepartments: async (
        username: string,
        password: string
    ): Promise<boolean> => {
        const response = await departmentEndPoints.getDepartments(
            username,
            password
        );

        if (!response.isSuccess) {
            return false;
        } else {
            const departments: Array<any> = response.data.data;
            store.dispatch(DepartmentActions.updateDepartments(departments));
            return true;
        }
    },
    setDepartments: (departments: Array<IDepartment> | null) => {
        store.dispatch(DepartmentActions.updateDepartments(departments));
    },
};

export default Api;
